export default {
  page_title: 'Home | Thanx',
  welcome: 'Welcome back',
  welcome_name: 'Welcome back, %{name}',
  subtitle: 'Here are some quick actions you can take today',
  needs_attention: {
    heading: 'Needs attention', // renders "NEEDS ATTENTION" via .small-caps CSS
    row1_product: 'RecoveryAI',
    row1_suffix: 'escalations need review',
    review_escalations: 'Review escalations', // → /recovery_ai/escalations
    // sr-only badge count label — NATIVE plural pair; t(key,{count}) auto-picks
    // the form. Do NOT use _one/_other (does NOT auto-pluralize here).
    count_label: '%{count} case needs attention',
    count_label_plural: '%{count} cases need attention',
  },
  promo: {
    image_alt: 'Promotion %{number}',
  },
  help: {
    title: 'Need Help?',
    text: 'Want ideas on what type of offer will be most effective for your business, or help setting one up? Our merchant success team is always here to help with any questions you might have.',
  },
  buttons: {
    view_campaign: 'View campaign results',
    create_campaign: 'Create a new campaign',
    update_digital: 'Update digital experiences',
    // FR-65 read tile is the RecoveryAI CTA: `explore_recovery_ai` before
    // activation, `recovery_ai_performance` once active. useFeedbackTiles picks.
    explore_recovery_ai: 'Explore RecoveryAI',
    recovery_ai_performance: 'See RecoveryAI performance',
    feedback_scorecard: 'Review feedback scorecard',
    feedback_report: 'Explore order satisfaction',
    points_performance: 'Review points performance',
    reward_performance: 'Review reward performance',
    billing: 'Update billing information',
  },
  metrics: {
    title: 'Program performance',
    revenue_capture_rate: {
      title: 'Revenue capture rate',
      unlock_your_rate: 'Unlock your rate',
      popovers: {
        // To be finalized
        section_1:
          'The percentage of your revenue attributed to loyalty members.',
        section_2:
          'This rate is for the latest complete calendar month where POS data for total revenue was provided.',
        section_3:
          'Total revenue attributed to loyalty members / Total revenue across all channels uploaded by you',
        section_4:
          'You import POS data for July shows that you made $10,000 in net revenue. Thanx can see that $3,000 of this was attributed to loyalty members giving you a capture rate of 30% for that month.',
      },
    },
    activation_rate: {
      title: 'Activation rate',
      popovers: {
        section_1:
          'The percentage of customers that made their 1st purchase in a given month and then went on to make a 3rd purchase within 120 days.',
        section_2:
          'Count of customers that made 3rd purchase / Count of customers that made 1st purchase',
        section_3:
          '1,000 customers made their 1st purchase in July. 300 of those customers went on to make their 3rd purchase within 120 days. The activation rate for July is 30%.',
      },
    },
    retention_rate: {
      title: 'Retention rate',
      popovers: {
        section_1:
          'The percentage of activated customers (Activated means this wasn’t their 1st or 2nd purchase) that made a purchase in a given month and then returned to make another purchase within 180 days.',
        section_1_multiple:
          'The percentage of activated customers (activated means this wasn’t their 1st or 2nd purchase) that made a purchase in a given month and then returned to make another purchase within a specific time window (e.g., within 30 days, 60 days, 90 days, etc).',
        section_2:
          '1,000 activated customers made a purchase in July. 300 of those customers returned within 180 days to make another purchase. The 180 day retention rate for July is 30%.',
      },
    },
    effective_discount_rate: {
      title: 'Effective discount rate',
      popovers: {
        section_1:
          'The cost of loyalty rewards that loyalty members redeemed relative to the revenue they generated for you.',
        section_2:
          'Cost of loyalty rewards / Total revenue attributed to loyalty members',
        section_3:
          'Loyalty members exchanged their points for rewards this month. The total cost of those rewards was $1,000. The total amount spent by loyalty members this month was $100,000. The effective discount rate for this month was 1%.',
      },
      requires_points: 'Requires Points',
    },
    order_satisfaction: {
      title: 'Order satisfaction',
      // sr-only label shown in place of the decorative em-dash when no ratings
      // exist yet, so the zero-state doesn't announce as a bare dash.
      no_data: 'No ratings yet',
      popovers: {
        section_1:
          'The share of rated orders where the guest gave a thumbs-up, across the last 15 days.',
        section_2:
          'Thumbs-up ratings / all ratings submitted in the last 15 days. Orders where the guest was prompted but never responded are not counted.',
      },
    },
    shared: {
      view_report: 'View report',
      metric_coming_soon: 'Coming soon',
      report_coming_soon: 'Report coming soon',
      benchmark: '%{rate} industry benchmark',
      industry_average: '%{rate} industry average',
      popovers: {
        example: 'EXAMPLE',
        how_its_calculated: 'HOW IT’S CALCULATED',
      },
      available_after_launch: 'Available after launch',
      available_in_x_days: 'Available in %{days} days',
      learn_more: 'Learn more',
    },
  },
  smart_links: {
    title: 'Smart Links',
  },
  crawl_walk_run: {
    title: 'Best Practices Framework to Grow',
  },
  insights_lab: {
    title: 'Insights Lab',
  },
  points_restriction: {
    title: 'Points Restrictions',
  },
  weekly_location_summary: {
    title: 'Weekly Location Summary',
  },
  settings_moved_modal: {
    title: 'Settings has moved',
    body_1:
      'Settings are now located in your Profile menu in the top-right corner.',
    body_2: 'To access them, click',
    body_2_bold: 'Profile \u2192 Settings',
    body_3: 'All of your settings and configurations remain the same.',
    go_to_settings: 'Go to Settings',
    okay: 'Okay',
  },
}
